import { toast } from "react-toastify";
import api from "../config/apiConfig";
import { getAdminId, getRegisterId } from "../utils/authId";
import { getSelectedCompany } from "../utils/auth";

export const viewUserAndRole = async (data) => {
  const id = getAdminId();

  try {
    const response = await api.get(
      `api/get_access_category?admin_id=${id}${data}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Add User and Role

export const AddUserandRoleAPi = async (formData) => {
  const id = getRegisterId();

  const data = {
    admin: id,
    ...formData,
  };
  try {
    const response = await api.post("api/add_access_category/", data);
    if (response) {
      toast.success("User Added Sucessfully", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {
    throw error.response.data;
  }
};

//edit User and role

export const EditUserAndRoleApi = async (formData) => {
  const id = getRegisterId();

  const data = {
    ...formData,
    admin: id,
  };
  try {
    const response = await api.put(
      `api/update_access_category/${formData.id}/`,
      data
    );
    if (response) {
      toast.success("Update successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {
    throw error;
  }
};

//active deactive

export const updateStatusApi = async (formData) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...formData,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(
      `api/access_category_active_deactive/`,
      data
    );
    if (response) {
      toast.success("Update successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {}
};
